
export const RegistrationStatus = {
  REGISTERED: 'Registered',
  NOT_REGISTERED: 'NotRegistered',
};
